import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';

import './OrderStatus.scss';

const OrderStatus = () => {
  return (
    <section className="order-status">
      <Container>
        <Title
          extraClassName="order-status__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          Статус ремонта в&nbsp;приложении
          <div className="order-status__title-icon"></div>
        </Title>

        <div className="order-status__list_wrapper">
          <div className="order-status__list">
            <div className="order-status__item order-status__item_first"></div>
            <div className="order-status__item order-status__item_second"></div>
            <div className="order-status__item order-status__item_third">
              <p>
                Скачайте приложение,
                <br /> наведя камеру телефона на&nbsp;QR&nbsp;код
              </p>
            </div>
          </div>
        </div>

        <div className="order-status__applinks">
          <a
            className="order-status__applink order-status__applink_apple"
            href="https://go.onelink.me/app/5d00e56e"
            rel="noreferrer"
            target="_blank"
          />

          <a
            className="order-status__applink order-status__applink_google"
            href="https://go.onelink.me/app/9c87f611"
            rel="noreferrer"
            target="_blank"
          />

          <a
            className="order-status__applink order-status__applink_huawei"
            href="https://appgallery.huawei.com/app/C104454319"
            rel="noreferrer"
            target="_blank"
          />
        </div>
      </Container>
    </section>
  );
};

export default OrderStatus;
